import { configureApiClient } from '@smartsash/api-client';
import { authChannelHeaders } from '@smartsash/auth';

import { env } from '@/env';

/**
 * Wire the shared `@smartsash/api-client` axios instance before any request runs
 * (HS-847 — admin now has no other HTTP client).
 *
 * The generated hooks carry the `/api` prefix themselves, so api-client needs the backend
 * ORIGIN. The trailing `/api` is stripped rather than removed from the env contract: cookie
 * auth (Secure + SameSite=None) needs a same-origin request, so `.env.example` deliberately
 * sets `VITE_API_BASE_URL=/api` and lets the Vite dev proxy keep cookies first-party. Both
 * forms are therefore valid input — `/api` → `''` (relative) and `http://host/api` → origin.
 *
 * Auth is cookie-based (HttpOnly cookies, `withCredentials`); the 401/refresh policy
 * is registered later by `@smartsash/auth` via `registerHttpHooks`. Every request carries
 * `X-Auth-Channel: admin`, so the API uses Admin's own session cookies rather than the pair it
 * would otherwise share with Portal (HS-1615).
 */
export function bootstrapApiClient(): void {
  const baseURL = env.VITE_API_BASE_URL.replace(/\/api\/?$/, '');
  configureApiClient({ baseURL, headers: authChannelHeaders('admin') });
}
